import { createFileRoute } from '@tanstack/react-router'
import { CommunicationPreferences } from '@/features/settings/communication'

export const Route = createFileRoute(
  '/_authenticated/settings/communication'
)({
  component: CommunicationPreferences,
})
